import React from "react";
import { PropTypes } from "prop-types";
import { HomePageLayout } from "application/home/components";
import { Category, CategoryPageHeader } from "application/categories/components";
import { MrbPageHeader } from "mrb/components/layout";
import { defaultTemplate } from "common/hoc";

function StationsPageTemplate({ stationsViewStore, t }) {
    return (
        <HomePageLayout store={stationsViewStore} t={t}>
            <div>
                <MrbPageHeader classNameExtend="c-page__header--secondary">
                    <CategoryPageHeader store={stationsViewStore} t={t} />
                </MrbPageHeader>
                <Category store={stationsViewStore} t={t} />
            </div>
        </HomePageLayout>
    );
}

StationsPageTemplate.propTypes = {
    stationsViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(StationsPageTemplate);
